<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
		{{ ('MODALS.HEADERS.CREATE_LINK' )| translate }}
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<fieldset [disabled]="formState ==='Submitting'">
	<form [formGroup]="createEdgeForm" class="edge-form">
        <mat-select class="edge-form-select body-m-regular text-extra select-rotate"
                    disableRipple panelClass="nd-select-status-in-out" 	
                    [placeholder]="('BUTTON_TEXT.SELECT' | translate) + ' - ' + ('MODALS.FIELDS.OUTCOMING_STATUS' | translate)  " formControlName="source_id"	>
                    <mat-label class="body-m-regular " style="margin-left: 12px;">{{ 'MODALS.FIELDS.OUTCOMING_STATUS' | translate }}</mat-label>
            @for (statusSelect of  this.nodesForConnection;  track statusSelect) {
                <mat-option class="body-m-regular edge-form-select-option text-extra " 
                     [disabled]="statusSelect.id === targetId.value"
                    [value]="statusSelect.id"  >
                    {{statusSelect?.label}}
                </mat-option>
            }
        </mat-select>
        <div class="edge-form-icon-row"> 
            <div class="edge-form-icon-row-circle"> 
                <mat-icon svgIcon="arrow-down-fill" class=""></mat-icon>  
            </div>
        </div>
        <mat-select class="edge-form-select body-m-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-status-in-out" 	
                    [placeholder]="('BUTTON_TEXT.SELECT' | translate) + ' - ' + ('MODALS.FIELDS.INCOMING_STATUS' | translate)  " formControlName="target_id"	>
                    <mat-label class="body-m-regular " style="margin-left: 12px;">{{ 'MODALS.FIELDS.INCOMING_STATUS' | translate }}</mat-label>
            @for (statusSelect of  this.nodesForConnection;  track statusSelect) {
                <mat-option  class="body-m-regular edge-form-select-option text-extra " 
                            [disabled]="statusSelect.id === sourceId.value"
                            [value]="statusSelect.id"  >
                    {{ statusSelect?.label }} 
                </mat-option>
            }
        </mat-select>

		<div class="edge-form-button-block">
			<button mat-dialog-close class="button-icon size-xl secondary-button"  [disabled]="this.formState === 'Submitting'">
				<mat-icon svgIcon="close-line"></mat-icon>
				{{ 'MODALS.BUTTONS.CANCEL'|translate }}
			</button>
			<button (click)="createNewEdge()"  data-action="createNewStatus updatStatus" 
				[disabled]="createEdgeForm.valid !==true || this.formState === 'Submitting'"
				class="button-icon size-xl primary-button" >
				<mat-icon svgIcon="save-2-fill"></mat-icon>
				{{('MODALS.BUTTONS.SAVE'|translate) }}
			</button>
		</div>
	</form>
</fieldset>